import { chatSdk } from '@wix/chat-sdk';
import { Experiments } from "../constants/experiments";
var getLocalizedFullName = function (source, t) {
    var _a, _b;
    if (!source) {
        return;
    }
    if (!chatSdk.isExperimentOn(Experiments.AllowFullNameLocalization)) {
        return source.name;
    }
    var fullName = source.fullName;
    var name = source.name;
    if ((source === null || source === void 0 ? void 0 : source.siteUserType) === 'Visitor' || !fullName) {
        return name;
    }
    var firstName = (_a = fullName.firstName) !== null && _a !== void 0 ? _a : '';
    var lastName = (_b = fullName.lastName) !== null && _b !== void 0 ? _b : '';
    return t('localized.fullname', { firstName: firstName, lastName: lastName }) || name;
};
export default getLocalizedFullName;
//# sourceMappingURL=localization.js.map